import routerOptions0 from "/home/user1/contest.qingmaoedu.com/learning_center.qingmaoedu.com/node_modules/.pnpm/nuxt@3.17.6_@parcel+watcher@2.5.1_@types+node@24.0.10_@vue+compiler-sfc@3.5.17_db0@0.3.2_iore_rwhlpjomnt62o2msxary6c3yp4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}